import { createApi } from '@reduxjs/toolkit/query/react';
import { GetUserDetail} from '../../api/endpoints';
import {baseQueryWithReauth} from "../../api/baseQuery";

export const getAdminDetailsApi =  createApi({
    reducerPath:'getAdminDetailsApi',
    baseQuery: baseQueryWithReauth,
endpoints:(builder)=>({
  getAdminDetails:builder.query({
      query:()=>({url:GetUserDetail, method:'GET'}),
      providesTags: [{ type: 'Detail', id: 'GET' }],
  })
})

})

export const {useGetAdminDetailsQuery} = getAdminDetailsApi;